"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param name - required
 * @param value - removes cookie value if undefined
 * @param path - default: current path
 * @param expires - accepts GMT format ONLY! use .toUTCString 'Fri, 21 Feb 2025 09:36:24 GMT' (default: one year after from now)
 */
function default_1({ name, value, path, expires, }) {
    const today = new Date();
    const defaultExpires = today;
    defaultExpires.setFullYear(today.getFullYear() + 1);
    document.cookie = `${name}=${value !== null && value !== void 0 ? value : ''};${path ? `path=${path};` : ''}expires=${expires !== null && expires !== void 0 ? expires : defaultExpires.toUTCString()};`;
}
exports.default = default_1;
